import React, {
  useCallback,
  useEffect,
  useState,
} from 'react';
import { useStateContext } from '../../hooks/useStateContext';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Dialog from '@mui/material/Dialog';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Chip, Stack } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import SecurityRoundedIcon from '@mui/icons-material/SecurityRounded';
import { UploadProfilePicture } from './UserSettings/UploadProfilePicture';
import api from '../../services/api';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

export const UserSettings = ({ onClose }: { onClose: () => void }) => {
  const { user } = useStateContext();

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [value, setValue] = React.useState(0);
  const [loading, setLoading] = useState<any>(false);

  const [userData, setUserData] = useState<any>(false);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchUserData = useCallback(() => {
    setLoading(true);
    api.get(`/users/${user.id}`).then((res: any) => {
      setUserData(res);
      setLoading(false);
    });
  }, []);

  return (
    <>
      <Dialog
        open={true}
        onClose={() => {
          if (loading) {
            return true;
          }
          onClose();
          return true;
        }}
        fullScreen={fullScreen}
        sx={{
          '& .MuiDialog-paper': {
            width: '100%',
          },
        }}
      >
        <Stack direction={'row'}>
          <Stack>
            <Box
              sx={{
                p: '15px',
                borderRight: '1px solid #e0e0e0',
              }}
            >
              <Stack
                alignItems={'center'}
                sx={{
                  p: '15px',
                  background: '#e0e0e0',
                  borderRadius: '6px',
                }}
              >
                <Avatar
                  sx={{
                    width: '80px',
                    height: '80px',
                    bgcolor: user?.avatar_color
                      ? user?.avatar_color
                      : '#678fff',
                  }}
                  src={
                    userData?.avatar?.link ? userData?.avatar?.link : undefined
                  }
                >
                  {!user?.avatar && user.name.charAt(0).toUpperCase()}
                </Avatar>
                <Typography variant={'h6'}>{user?.name}</Typography>
                <Stack alignItems={'flex-start'}>
                  {user?.roles.map((role: any) => {
                    return (
                      <>
                        <Chip
                          size={'small'}
                          sx={{
                            color: '#c9c9c9',
                            background: '#c9c9c929',
                            '& .MuiChip-icon': {
                              color: '#c9c9c9',
                            },
                          }}
                          icon={
                            <SecurityRoundedIcon fontSize={'small'} sx={{}} />
                          }
                          label={role?.name}
                        />
                      </>
                    );
                  })}
                </Stack>
              </Stack>
            </Box>

            <Tabs
              orientation="vertical"
              variant="scrollable"
              value={value}
              onChange={handleChange}
              aria-label="Vertical tabs example"
              sx={{ borderRight: 1, borderColor: 'divider' }}
            >
              <Tab label="Profile Picture" {...a11yProps(0)} />
              {/* <Tab label="Item Two" {...a11yProps(1)} />*/}
            </Tabs>
          </Stack>

          <Box>
            <TabPanel value={value} index={0}>
              <UploadProfilePicture
                uploading={(value) => {
                  setLoading(value);
                }}
                setProfilePicture={(url) => {
                  const avatar = { ...userData.avatar };
                  avatar.link = url;
                  setUserData({ ...userData, ['avatar']: avatar });
                }}
              />
            </TabPanel>
            <TabPanel value={value} index={1}>
              Item Two
            </TabPanel>
          </Box>
        </Stack>
      </Dialog>
    </>
  );
};
